module.exports = __webpack_public_path__ + "assets/img/preview_01.3e85df9b.png";